// extracted by mini-css-extract-plugin
export default {"body":"Modal_body__Nswb0","body__textBlock":"Modal_body__textBlock__QApxq"};